export default __webpack_public_path__ + "static/media/login_horse.89e8f90b.png";